export function validateSocial(value, social) {

	let specialPrefix = [];
	if(social === 'youtube') {
		specialPrefix = ['channel', 'c', 'user'];
	} else if(social === 'linkedin') {
		specialPrefix = ['in', 'company'];
	}

	if(value) {
		if(value.endsWith('/')) { value = value.slice(0, -1); }
		if(value.includes('/')){
			let splitVal = value.split('/');
			let username = splitVal[splitVal.length - 1];
			if(splitVal.length > 1 && specialPrefix.includes(splitVal[splitVal.length - 2])) {
				value = splitVal[splitVal.length - 2] + '/' + username;
			} else {
				value = username;
			}
		}
		value = cleanSocialString(value);
		return value;
	} else {
		return '';
	}
}

function cleanSocialString(str) {
	return str ? str.replace(/[^0-9a-z-A-Z-_.@/]/g, "") : '';
}